import { fullName } from '@bondsports/general';
import { SimpleTooltip, Text } from '@components/atoms';
import { Price } from '@components/molecules/price/price';
import { isPriceValid } from '../../util';
import type { CartItemProps } from '../types';
import { CartItemActions } from './cart-item-actions';

type CartItemDetailsProps = Pick<
	CartItemProps,
	| 'item'
	| 'onDeleteItem'
	| 'isLoading'
	| 'onDiscountItem'
	| 'disableDiscount'
	| 'currency'
	| 'disableDelete'
	| 'isChild'
	| 'cartItemDescriptionLabel'
>;

export const CartItemDetails = ({
	item,
	onDeleteItem,
	isLoading,
	onDiscountItem,
	disableDelete,
	disableDiscount,
	currency,
	isChild,
	cartItemDescriptionLabel,
}: CartItemDetailsProps) => {
	const metadataLabel = cartItemDescriptionLabel?.(item);
	return (
		<div className="row-span-2 flex w-full flex-row items-start justify-between gap-1">
			<div className="flex min-w-0 flex-col gap-1" data-testid="cart-item-details">
				<SimpleTooltip content={item.product?.name ?? ''} asChild>
					<Text size="sm" weight="medium" truncate>
						{item.product?.name ?? ''}
					</Text>
				</SimpleTooltip>
				{isPriceValid(item.unitPrice) &&
					(item.unitPrice ? (
						<Price
							size="xs"
							color="mediumGray"
							currency={currency}
							price={item.unitPrice ?? 0}
							parse={price => (metadataLabel ? `${price} | ${metadataLabel}` : `${price}`)}
							className="capitalize"
						/>
					) : (
						<Text size="xs" color="mediumGray" className="capitalize">
							{metadataLabel}
						</Text>
					))}
				{!isChild && (
					<Text size="xs" color="mediumGray">
						{fullName(item.user?.firstName, item.user?.lastName)}
					</Text>
				)}
			</div>
			<CartItemActions
				item={item}
				onDeleteItem={onDeleteItem}
				isLoading={isLoading}
				onDiscountItem={onDiscountItem}
				disableDiscount={disableDiscount}
				disableDelete={disableDelete}
			/>
		</div>
	);
};
